<!--  -->
<template>
  <div class="search-bar">
    <el-input class="input" :value="value" @input="onChange" @keyup.enter.native="searchHandler"> </el-input>
    <el-button class="input-button" icon="el-icon-search" @click.native="searchHandler"></el-button>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    onChange(val) {
      this.$emit("input", val);
    },
    searchHandler() {
      this.$emit("search");
    },
  },
};
</script>
<style lang="scss" scoped>
.search-bar {
  display: flex;
  align-items: center;
  .input-button {
    width: 160px;
    height: 60px;
    background: #333333;
    color: #fff;
    font-size: 30px;
    margin-left: -80px;
    z-index: 1;
  }
  .input {
    width: 950px;
    /deep/ input {
      width: 950px;
      height: 80px;
      background: #f8f8f8;
      border: 1px solid #f0f0f0;
    }
  }
}
</style>
